import { Box } from "@mui/material";
import { AdminConsoleHeader } from "./AdminConsoleHeader";

interface ITemplateDefaultAdminConsole {
    iconTitle: React.ReactNode;
    title: string;
    subtitle: string;
    children: React.ReactNode;
}

export const TemplateDefaultAdminConsole: React.FC<ITemplateDefaultAdminConsole> = ({
    iconTitle,
    title,
    subtitle,
    children
}) => {

    return (
        <>
            <Box sx={{
                padding: '15px 30px',
                backgroundColor: '#F7F8FA',
                height: '100%'
            }}>

                <Box sx={{
                    background: '#FFFFFF 0% 0% no-repeat padding-box',
                    border: '1px solid #0000001A',
                    borderRadius: '4px',
                    padding: '30px',
                    height: '100%'
                }}>
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: '20px',
                        height: 'calc(100% + 30px)',
                    }}>
                        <AdminConsoleHeader
                            iconTitle={iconTitle}
                            title={title}
                            subtitle={subtitle} />
                        <Box sx={{ height: '100%', overflowY: 'auto' }} >
                            {children}
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
    );
};